import 'jquery';

export class Layout {
    addUpdateToComponentsOnPageReady() {
        var that = this;
        $(document).ready(function () {
            that.updateComponentsOnPage();
        });
    }

    /*
    * updateComponentsOnPage rerender components after page has loaded
    */
    updateComponentsOnPage() {
        this.recalcAllDataTablesWithPluginResponsiveThatIsVisible();
        this.recalcAllHighchartsThatIsVisible();
    }

    /*
    * addUpdateToComponentsOnTabClick updates the components layout when a bootstrap tab is clicked.
    */
    addUpdateToComponentsOnTabClick() {
        var that = this;
        $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function () {
            that.updateComponentsOnPage();
        });
    }

    recalcAllDataTablesWithPluginResponsiveThatIsVisible() {
        if (typeof $.fn.dataTable !== "undefined") {
            $.fn.dataTable.tables({ visible: true, api: true }).responsive.recalc();
        }
    }

    recalcAllHighchartsThatIsVisible() {
        $.each($('.highcharts-container:visible'), function () { var chartApi = $(this).parent().highcharts(); chartApi.reflow(); chartApi.redraw(); });
    }
}